import { auth, authUserUId, setAuthCache, setUser, getContinueUrl } from './FirebaseAPI'

export function signIn() {
  if (authUserUId()) {
    console.log("sign in")
    return true
  }
  else {
    console.log("not sign in")
    sendSignInEmail()
    return false
  }
}

function sendSignInEmail() {
  var actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be whitelisted in the Firebase Console.
    url: window.location.href,
    // This must be true.
    handleCodeInApp: true
  }
  var email = window.prompt('Please provide your email in order to login.');
  if (!email) return
  console.log('sendSignInEmail')
  auth.sendSignInLinkToEmail(email, actionCodeSettings)
  .then(function() {
    // The link was successfully sent. Inform the user.
    // Save the email locally so you don't need to ask the user for it again
    // if they open the link on the same device.
    window.alert('A secure login link has been sent to ' + email + '. Please check your email.')
    console.log('sendSignInEmail sent')
    window.localStorage.setItem('emailForSignIn', email);
  })
  .catch(function(error) {
    console.log('sendSignInEmail', error)
    // Some error occurred, you can inspect the code: error.code
  });
}

export async function completeSignIn(url) {
  if (auth.isSignInWithEmailLink(url)) {
    console.log('isSignInWithEmailLink')

    var email = window.localStorage.getItem('emailForSignIn');
    if (!email) {
      // User opened the link on a different device. To prevent session fixation
      // attacks, ask the user to provide the associated email again. For example:
      email = window.prompt('Please provide your email for confirmation');
    }

    var result =  await auth.signInWithEmailLink(email, window.location.href)
    if (result) {
      var user = result.user
      setAuthCache(user)
      await setUser({email:user.email})

      //console.log('isSignInWithEmailLink user', user)
      return true
    }

  }
  return false
}



// WEBPACK FOOTER //
// ./src/api/EmailLinkAuthentication.js